"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadButton = exports.HoverHighlightAnchor = exports.ActionButton = exports.CancelButton = exports.AlertButton = exports.OutlineButton = exports.LinkButton = exports.PrimaryButton = exports.BlockButton = exports.InvisibleButton = exports.Button = exports.ButtonStyles = void 0;
var React = require("react");
var react_1 = require("react");
var typestyle_1 = require("typestyle");
var utils_1 = require("../utils");
var ButtonStyles;
(function (ButtonStyles) {
    ButtonStyles[ButtonStyles["PRIMARY"] = 0] = "PRIMARY";
    ButtonStyles[ButtonStyles["CANCEL"] = 1] = "CANCEL";
    ButtonStyles[ButtonStyles["ACTION"] = 2] = "ACTION";
    ButtonStyles[ButtonStyles["ALERT"] = 3] = "ALERT";
    ButtonStyles[ButtonStyles["LINK"] = 4] = "LINK";
    ButtonStyles[ButtonStyles["OUTLINE"] = 5] = "OUTLINE";
})(ButtonStyles = exports.ButtonStyles || (exports.ButtonStyles = {}));
var Button = (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var props = this.props;
        var style = props.style || ButtonStyles.PRIMARY;
        var styleClass = "";
        switch (style) {
            case ButtonStyles.CANCEL:
                styleClass = "btn-cancel";
                break;
            case ButtonStyles.ACTION:
                styleClass = "btn-link";
                break;
            case ButtonStyles.ALERT:
                styleClass = "btn-danger";
                break;
            case ButtonStyles.LINK:
                styleClass = "btn-link";
                break;
            case ButtonStyles.OUTLINE:
                styleClass = "btn-outline-primary";
                break;
            default:
                styleClass = "btn-primary";
                break;
        }
        var base = "ml-1 btn";
        var fullWidth = props.fullWidth ? "btn-block" : "";
        var noMargin = props.noMargin ? "Button--nomargin" : "";
        var noHMargin = props.noHMargin ? "Button--no-horizontal-margin" : "";
        var className = (0, typestyle_1.classes)(base, fullWidth, styleClass, noMargin, noHMargin, props.className);
        return (React.createElement("button", { id: props.id, autoFocus: props.focus, type: props.type || "button", disabled: props.disabled, onClick: props.onClick, onBlur: props.onBlur, ref: props.buttonRef, tabIndex: props.tabIndex, title: props.title, className: className, style: { zIndex: 'auto' } }, props.children));
    };
    return Button;
}(React.Component));
exports.Button = Button;
var InvisibleButton = (function (_super) {
    __extends(InvisibleButton, _super);
    function InvisibleButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvisibleButton.prototype.render = function () {
        var props = this.props;
        return (React.createElement("span", { onClick: props.onClick, ref: props.buttonRef, className: "InvisibleButton" }, props.children));
    };
    return InvisibleButton;
}(React.Component));
exports.InvisibleButton = InvisibleButton;
var BlockButton = function (props) {
    return (React.createElement(Button, __assign({ onClick: props.onClick, fullWidth: true }, props), props.children));
};
exports.BlockButton = BlockButton;
var PrimaryButton = function (props) {
    return (React.createElement(Button, __assign({ style: ButtonStyles.PRIMARY }, props), props.children));
};
exports.PrimaryButton = PrimaryButton;
var LinkButton = function (props) {
    return (React.createElement(Button, __assign({ style: ButtonStyles.LINK }, props), props.children));
};
exports.LinkButton = LinkButton;
var OutlineButton = function (props) {
    return (React.createElement(Button, __assign({ style: ButtonStyles.OUTLINE }, props), props.children));
};
exports.OutlineButton = OutlineButton;
var AlertButton = function (props) {
    return (React.createElement(Button, __assign({ style: ButtonStyles.ALERT }, props), props.children));
};
exports.AlertButton = AlertButton;
var CancelButton = function (props) {
    return (React.createElement(Button, __assign({ style: ButtonStyles.CANCEL }, props), props.children));
};
exports.CancelButton = CancelButton;
var ActionButton = function (props) {
    return (React.createElement(Button, __assign({ style: ButtonStyles.ACTION }, props), props.children));
};
exports.ActionButton = ActionButton;
var HoverHighlightAnchor = (function (_super) {
    __extends(HoverHighlightAnchor, _super);
    function HoverHighlightAnchor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HoverHighlightAnchor.prototype.onClick = function (e) {
        (0, utils_1.preventDefault)(e);
        this.props.onClick && this.props.onClick();
    };
    HoverHighlightAnchor.prototype.render = function () {
        var props = this.props;
        return (React.createElement("a", { className: "HoverHighlightAnchor", onClick: this.onClick.bind(this) }, props.children));
    };
    return HoverHighlightAnchor;
}(React.Component));
exports.HoverHighlightAnchor = HoverHighlightAnchor;
var FileUploadButton = function (props) {
    var inputRef = (0, react_1.useRef)(null);
    var handleUpload = function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { ref: inputRef, className: "d-none", type: "file", onChange: function (e) {
                props.uploader(e.target.files[0]);
            } }),
        React.createElement(Button, { onClick: handleUpload, className: props.className, style: props.style || ButtonStyles.PRIMARY, fullWidth: props.fullWidth || false }, props.caption)));
};
exports.FileUploadButton = FileUploadButton;
